import _extends from "@babel/runtime/helpers/extends";
import { Box, SectionHelper } from '@wix/design-system';
import React from 'react';
import { useCycleAvailability } from '../../hooks/useCycleAvailability';
import { YEARLY_CYCLE_ID, YEARLY_PURCHASE_CYCLE } from '../../utils/consts';
import { useCurrentModule } from '../ModuleProvider';
import s from './CycleSelectorDisabledFeatures.scss';
import { useSelectCycleFromMonthlyNote } from './useSelectCycleFromMonthlyNote';
export const MonthlyCycleUpsellHelper = _ref => {
  let {
    productId,
    mobile
  } = _ref;
  const module = useCurrentModule();
  const {
    t,
    Trans
  } = module.internals.useTranslations();
  const selectCycle = useSelectCycleFromMonthlyNote();
  const {
    isCycleAvailable: isYearlyCycleAvailable,
    isLoading: isYearlyAvailabilityLoading
  } = useCycleAvailability(productId, YEARLY_PURCHASE_CYCLE);
  const actionProps = isYearlyCycleAvailable ? {
    actionText: t('cycle_entry.monthly_disclaimer.upsell_cta'),
    onAction: selectCycle(YEARLY_CYCLE_ID, 'select-1year-cycle')
  } : {};
  if (isYearlyAvailabilityLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    className: s.upsellHelper,
    width: "100%",
    marginTop: mobile ? '6px' : '12px',
    marginBottom: mobile ? '6px' : undefined
  }, /*#__PURE__*/React.createElement(SectionHelper, _extends({
    dataHook: "monthly-cycle-upsell-helper",
    skin: "premium",
    fullWidth: true,
    showPrefixIcon: false
  }, actionProps), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "cycle_entry.monthly_disclaimer.upsell"
  })));
};
//# sourceMappingURL=MonthlyCycleUpsellHelper.js.map